import type { ConversationMainline } from '#/shared/api/generated/communication/models'
import { formatPhone } from '#/shared/lib/format'

/**
 * Routing label for a shared-mainline thread row, ordered by the last item's
 * direction — outbound reads "mainline → counterparty" (we sent it), inbound
 * (and unknown) reads "counterparty → mainline" (they reached our shared line).
 * Returns null when neither side resolves to a number.
 */
export function mainlineRouteLabel(
  counterpartyNumber: string | null | undefined,
  mainline: ConversationMainline,
  direction?: string | null,
): string | null {
  const them = formatPhone(counterpartyNumber)
  const ours = formatPhone(mainline.phone_number)
  if (!them && !ours) return null
  const [from, to] = direction === 'outbound' ? [ours, them] : [them, ours]
  return `${from} → ${to}`
}
